import type { ReactNode } from 'react';

import { cn } from '@/lib/cn';

/**
 * Il contenitore di una sezione: una superficie opaca che raccoglie contenuto
 * e controlli.
 *
 * Serve per LEGGIBILITÀ, non per decorazione. Lo sfondo dell'app è una texture
 * a scaglie ad alto contrasto locale: testo e schede appoggiati direttamente
 * sopra ricadono a volte su una scaglia chiara, a volte su una scura, e il
 * bordo del motivo passa dietro le lettere. Una superficie opaca sotto il
 * contenuto elimina il problema alla radice, invece di rincorrerlo alzando il
 * contrasto di ogni singolo elemento.
 *
 * Non è traslucido di proposito: un fondo semitrasparente lascerebbe passare
 * proprio il motivo da cui stiamo proteggendo il testo.
 */
export function SectionCard({
  children,
  className,
  /** Il contenuto porta il proprio scorrimento: la card allora non impagina. */
  flush,
}: {
  children: ReactNode;
  className?: string;
  flush?: boolean;
}) {
  return (
    <div
      className={cn(
        // `bg-bg` e' il teal PIU' SCURO della palette, lo stesso della barra in
        // basso. Deve stare sotto le schede interne, non alla loro altezza: con
        // `bg-bg-secondary` (il colore delle righe) card e contenuto si
        // fondevano in un'unica massa piatta. Il fondo va sempre piu' scuro del
        // contenuto che regge, altrimenti non e' un fondo.
        'card-edge rounded-2xl bg-bg',
        flush ? '' : 'p-3',
        className,
      )}
    >
      {children}
    </div>
  );
}
